var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Swiper',{attrs:{"imgs":_vm.goods_imgs_url,"actSrc":_vm.activity_tag_img,"isShowSkuPic":true}})}
var staticRenderFns = []

export { render, staticRenderFns }